import { CancelablePromise, OpenAPI } from "../generated";

export class AvvCustomService {
    /**
     * Download AVV PDF for current user
     * Uses direct fetch to properly handle Blob response
     * @returns Blob AVV PDF file
     * @throws Error if download fails
     */
    public static downloadAvvPdf(): CancelablePromise<Blob> {
        return new CancelablePromise(async (resolve, reject) => {
            try {
                const response = await fetch(
                    `${OpenAPI.BASE}/v2/api/user/avv`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                            Accept: "application/pdf",
                        },
                    }
                );

                if (!response.ok) {
                    const errorText = await response.text();
                    throw new Error(errorText || "Failed to download AVV PDF");
                }

                const blob = await response.blob();
                if (blob.size === 0) {
                    throw new Error("Received empty file");
                }

                resolve(blob);
            } catch (error) {
                reject(error);
            }
        });
    }
}
